import React, {useEffect, useState} from "react"
import {CheckoutClosingsFilters, usePaginatedCheckoutClosings} from "../utils/hooks/usePaginatedCheckoutClosings.ts";
import {useIntersect} from "../utils/hooks/useIntersect.ts";
import {formatDate, formatPrice, Schema} from "../utils";
import {Loader} from "./Loader.tsx";
import {useCore} from "../hooks";
import {Btn} from "./Btn.tsx";
import {useNavigate} from "react-router";

export const CheckoutDetailClosingsList: React.FC = () => {
  const { selectedDetailCheckoutId, currency } = useCore()
  const navigate = useNavigate()
  const { measureRef, isIntersecting } = useIntersect()
  const [filters, setFilters] = useState<CheckoutClosingsFilters>({
    checkouts: [Number(selectedDetailCheckoutId)],
  })

  const filter = () => {
    setFilters({
      checkouts: [Number(selectedDetailCheckoutId)],
    })
  }

  const clearFilters = () => {
    setFilters({
      checkouts: [Number(selectedDetailCheckoutId)],
    })
  }

  const { refresh, checkoutClosings, loading, loadMore, isLastPage, totalCount } = usePaginatedCheckoutClosings({
    filters: {
      ...filters
    },
    sort: 'id',
    direction: 'DESC',
    schema: Schema.checkoutClosing.list,
  })

  const showCheckoutClosingDetail = (closingId: number) => {
    navigate(`/checkout-detail/checkout-closing/${closingId}`)
  }

  useEffect(() => {
    if (isIntersecting) {
      loadMore()
    }
  }, [isIntersecting])

  useEffect(() => {
    filter()
  }, [selectedDetailCheckoutId])

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th className="text-left">POKLADNA</th>
              <th className="text-left">DATUM OTEVŘENÍ POKLADNY</th>
              <th className="text-left">SKUTEČNÝ STAV</th>
              <th className="text-left">DATUM UZAVŘENÍ POKLADNY</th>
              <th className="text-left">SKUTEČNÝ STAV</th>
              <th className="text-right"></th>
            </tr>
          </thead>
          <tbody>
            {checkoutClosings?.length > 0 ? checkoutClosings.map(closing => (
              <tr key={`closing-row-${closing.id}`}>
                <td>{closing.checkout?.name}</td>
                <td>{closing.dateOpen?.length ? formatDate(new Date(closing.dateOpen), false, true) : ''}</td>
                <td className="">{formatPrice(closing.amountRealOpen || 0, currency.id)}</td>
                <td>{closing.dateClosed?.length ? formatDate(new Date(closing.dateClosed), false, true) : ''}</td>
                <td className="">{formatPrice(closing.amountRealClosed || 0, currency.id)}</td>
                <td className="text-right">
                  <Btn
                    className="btn-link btn text-primary"
                    children={'Zobrazit uzávěrku'}
                    icon={'fa-scale-balanced'}
                    onClick={() => showCheckoutClosingDetail(closing.id)}
                  />
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={6} className="text-center py-4">
                  {loading ? <Loader /> : <span className="text-base-400">žádné uzávěrky</span>}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!isLastPage && (
        <div ref={measureRef} className="text-center py-4">
          <span className="text-base-400">next page..</span>
        </div>
      )}
    </div>
  )
}
